import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addAlterarEmpresa as addAlterarEmpresaApi,
  addAutoAtendimentoAutoAtendimento as addAutoAtendimentoAutoAtendimentoApi,
  addAutoAtendimentoCliente as addAutoAtendimentoClienteApi,
  atendimentos as atendimentoseApi,
  controleAtendimento as controleAtendimentoApi,
  finalizarAutoAtendimento as finalizarAutoAtendimentoApi,
  liberadaAutoAtendimento as liberadaAutoAtendimentoApi,
  painelControle as painelControleApi,
  relatorio as relatorioApi,
} from "../../helpers/backend_helper";

export const controleAtendimento = createAsyncThunk(
  "ControleAtendimento",
  async (params: { page: number; limit: number }) => {
    try {
      const response = await controleAtendimentoApi(params.page, params.limit);
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const relatorio = createAsyncThunk(
  "relatorio",
  async (params: { page: number; limit: number; data: any }) => {
    try {
      const response = await relatorioApi(
        params.page,
        params.limit,
        params.data
      );
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const atendimentos = createAsyncThunk(
  "atendimentos",
  async (params: { page: number; limit: number }) => {
    try {
      const response = await atendimentoseApi(params.page, params.limit);
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const painelControleCliente = createAsyncThunk(
  "painelControle",
  async (params: { page: number; limit: number }) => {
    try {
      const response = await painelControleApi(
        params.page,
        params.limit,
        "CLIENTE"
      );
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const painelControleAutoAtendimento = createAsyncThunk(
  "painelControleAutoAtendimento",
  async (params: { page: number; limit: number }) => {
    try {
      const response = await painelControleApi(
        params.page,
        params.limit,
        "AUTO_ATENDIMENTO"
      );
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const addAutoAtendimentoCliente = createAsyncThunk(
  "addAutoAtendimentoCliente",
  async (empresa: any) => {
    try {
      const response = await addAutoAtendimentoClienteApi(empresa);
      toast.success("Empresa adicionado com sucesso !", { autoClose: 2000 });
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const addAutoAtendimentoAutoAtendimento = createAsyncThunk(
  "addAutoAtendimentoAutoAtendimento",
  async (empresa: any) => {
    try {
      const response = await addAutoAtendimentoAutoAtendimentoApi(empresa);
      toast.success("Empresa adicionado com sucesso !", { autoClose: 2000 });
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const finalizarAutoAtendimento = createAsyncThunk(
  "finalizarAutoAtendimento",
  async (empresa: any) => {
    try {
      const response = await finalizarAutoAtendimentoApi(empresa);
      toast.success("Empresa finalizada com sucesso !", { autoClose: 2000 });
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const liberarAutoAtendimento = createAsyncThunk(
  "liberarAutoAtendimento",
  async (empresa: any) => {
    try {
      const response = await liberadaAutoAtendimentoApi(empresa);
      toast.success("Empresa liberada com sucesso !", { autoClose: 2000 });
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);

export const addAlterarEmpresa = createAsyncThunk(
  "addAlterarEmpresa",
  async (empresa: any) => {
    try {
      const response = await addAlterarEmpresaApi(empresa);
      toast.success("Empresa alterado com sucesso !", { autoClose: 2000 });
      return response;
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error === undefined
          ? "Erro ao executar o sistema !"
          : error?.response?.data?.error,
        { autoClose: 2000 }
      );
      return error;
    }
  }
);
